import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types/RootState';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.dataCatalog || initialState;

export const selectDataCatalog = createSelector([selectDomain], state => state);
